import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = {
  key: 1,
  class: "text-success"
}
const _hoisted_20 = { class: "col-12 mb-3" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-6 mb-3" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-6 mb-3" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_29 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "card-header" }, "Nouveau Colis", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "row",
        onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editColis && _ctx.editColis(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "can_open" }, "Colis", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              id: "can_open",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.colisData.can_open) = $event))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("option", { value: "1" }, "Ouvrir le colis", -1),
              _createElementVNode("option", { value: "0" }, "Ne pas ouvrir le colis", -1)
            ]), 512), [
              [_vModelSelect, _ctx.colisData.can_open]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "replace" }, "Colis Change", -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "replace",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.colisData.replace) = $event)),
                "true-value": 1,
                "false-value": 0
              }, null, 512), [
                [_vModelCheckbox, _ctx.colisData.replace]
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "form-check-label",
                for: "replace"
              }, [
                _createElementVNode("span", null, "Colis Change"),
                _createElementVNode("span", { style: {"font-size":"12px"} }, [
                  _createElementVNode("br"),
                  _createTextVNode("( Le colis sera remplacer avec l'ancien a la livraison. ) ")
                ])
              ], -1))
            ]),
            (_ctx.colisData.replace == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label fw-medium text-black fs-13" }, "Code du colis remplacé", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.colisData.code_replace) = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchColis())),
                    placeholder: "Code de suivi"
                  }, null, 544), [
                    [_vModelText, _ctx.colisData.code_replace]
                  ]),
                  (_ctx.existcolis)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Ce colis n'existe pas"))
                    : _createCommentVNode("", true),
                  (_ctx.replacecolis)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Vous ne pouvez pas remplacer ce colis"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("hr")
        ], -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "code" }, "Code de suivi", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "code",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.colisData.code) = $event)),
              placeholder: "Code de suivi"
            }, null, 512), [
              [_vModelText, _ctx.colisData.code]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "dest" }, "Destinataire", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "dest",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.colisData.receiver) = $event)),
              placeholder: "Destinataire",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.colisData.receiver]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "phone" }, "Numéro de téléphone *", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.blackList(_ctx.colisData.phone))),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validatePhone())),
              id: "phone",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.colisData.phone) = $event)),
              placeholder: "0XXXXXXXXX",
              maxlength: "10",
              pattern: "0[0-9]{9}",
              required: "",
              onKeypress: _cache[9] || (_cache[9] = ($event: any) => {if (isNaN(Number($event.key))) $event.preventDefault();})
            }, null, 544), [
              [_vModelText, _ctx.colisData.phone]
            ]),
            (_ctx.phoneError)
              ? (_openBlock(), _createElementBlock("small", _hoisted_17, " Numéro invalide (doit commencer par 0 et contenir 10 chiffres) "))
              : _createCommentVNode("", true),
            (!_ctx.phoneError && _ctx.error_blacklst.msg)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.error_blacklst.msg == 'exist')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_18, " Ce numéro est dans la black liste ( " + _toDisplayString(_ctx.error_blacklst.count) + " fois) ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.error_blacklst.msg == 'not exist')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_19, "Ce numéro est sûr"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { for: "city" }, "Ville", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              id: "city",
              required: "",
              label: "name",
              modelValue: _ctx.city,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.city) = $event)),
              options: _ctx.citiesList,
              placeholder: "Ville",
              onInput: _cache[11] || (_cache[11] = ($event: any) => {
                  _ctx.GetFees(_ctx.city);
                })
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "adresse" }, "Adresse", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "adresse",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colisData.address) = $event)),
              rows: "2",
              placeholder: "Adresse",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.colisData.address]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "comment" }, "Commentaire", -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "comment",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colisData.note) = $event)),
              rows: "2",
              placeholder: "Commentaire"
            }, null, 512), [
              [_vModelText, _ctx.colisData.note]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "price" }, "Prix", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              id: "price",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colisData.price) = $event)),
              min: "0",
              placeholder: "Prix",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.colisData.price]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { for: "product_nature" }, "Nature Du Produit", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "product_nature",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colisData.product_nature) = $event)),
              placeholder: "Nature Du Produit"
            }, null, 512), [
              [_vModelText, _ctx.colisData.product_nature]
            ])
          ])
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-12 mb-3" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary float-right"
          }, " Enregistrer ")
        ], -1))
      ], 32)
    ])
  ]))
}